var styles = {"IconContainer":"styles-module_IconContainer__Tch8v","ToggleDrawer":"styles-module_ToggleDrawer__U7ZZK"};

export { styles as default };
